import { gql } from '@apollo/client'

export const GET_FANTASY_LEAGUE = gql`
  query GetFantasyLeague($id: ID!) {
    fantasyLeague(id: $id) {
      id
      name
      isPublic
      secretCode
      maxPlayers
      image
      participantsCount
      creator {
        id
        fullName
        picture
      }
      members {
        id
        role
        budget
        teamName
        activityLastReadAt
        messagesLastReadAt
        unreadEventsCount
        unreadMessagesCount
        unreadActivityCount
        user {
          id
          fullName
          picture
          updatedAt
        }
        fantasyTeamPlayers {
          id
          createdAt
          startingPosition
          releaseClause
          signedAt
          individuallyProtected
          weeklyWindowProtected
          releaseClausePayable
          fantasyLeagueMember {
            id
          }
          player {
            id
            createdAt
            nick
            name
            lastName
            role
            marketValue
            image
            totalScore
            lastWeekScore
            lastWeekNumber
            team {
              id
              competition {
                id
                code
                displayName
                rank
              }
              createdAt
              nameShow
              shortName
              shield
            }
          }
        }
      }
      activeMarketEntries {
        id
        price
        status
        listedAt
        expiresAt
        player {
          id
          createdAt
          nick
          name
          lastName
          role
          marketValue
          image
          totalScore
          lastWeekScore
          lastWeekNumber
          team {
            id
            competition {
              id
              code
              displayName
              rank
            }
            createdAt
            nameShow
            shortName
            shield
          }
        }
        seller {
          id
          user {
            id
            fullName
          }
        }
      }
      visibleBids {
        id
        createdAt
        amount
        status
        marketEntry {
          id
          player {
            id
            createdAt
            nick
            name
            lastName
            role
            marketValue
            image
            totalScore
            lastWeekScore
            lastWeekNumber
            team {
              id
              competition {
                id
                code
                displayName
                rank
              }
              createdAt
              nameShow
              shortName
              shield
            }
          }
          seller {
            id
            user {
              id
              fullName
            }
          }
        }
        bidder {
          id
          user {
            id
            fullName
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`
